<template>
  <div class="unsubscribe-form">
    <fieldset v-if="!showConfirmation && !showError && !showSuccess">
      <div class="row">
        <div class="column column-100">
          <div class="message" v-html="labels['unsubscribeEmailText']"></div>
        </div>
      </div>
      <div class="row">
        <div class="column column-100">
          <input type="email" name="email" v-validate="'required|email'" @input="updateEmail" :placeholder="labels['email']" :value="email">
          <small v-show="errors.has('email')" class="help error">{{ errors.first('email') }}</small>
        </div>
      </div>
      <div class="row">
        <div class="column column-100">
          <div class="message" v-html="labels['unsubscribeFeedbackText']"></div>
        </div>
      </div>
      <div class="row">
        <div class="column column-100">
          <textarea class="feedback" :placeholder="labels['unsubscribeFeedbackPlaceholder']" @input="updateFeedback" :value="feedback"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="column column-100">
          <button class="button button-outline donate" @click="unsubscribe">{{ action }}</button>
        </div>
      </div>
    </fieldset>
    <div v-if="showError" class="row">
      <div class="column column-100">
        <div class="message" v-html="labels['unsubscribeError']"></div>
      </div>
    </div>
    <div v-if="showConfirmation" class="row">
      <div class="column column-100">
        <div class="message" v-html="labels['unsubscribeConfirmation'](email)"></div>
      </div>
    </div>
    <div v-if="showSuccess" class="row">
      <div class="column column-100">
        <div class="message" v-html="labels['unsubscribeSuccess']"></div>
        <div class="other-methods">
          <div class="other-methods-title">{{ labels['otherMethodsTitle'] }}</div>
          <div class="method-item" v-if="lang === 'ru'">
            <div class="method-header">
              <img class="method-icon" :src="require('@/assets/' + methods['zaodno'].icon)" />
              <div class="method-label">{{ labels['otherMethodsZaodnoLabel'] }}</div>
            </div>
            <div class="method-description" v-html="labels['otherMethodsZaodnoDescription']"></div>
            <div class="method-footer">
              <a class="button button-outline method-button" target="_blank" :href="methods['zaodno'].url">{{ labels['otherMethodsZaodnoButton'] }}</a>
            </div>
          </div>
          <div class="method-item">
            <div class="method-header">
              <img class="method-icon" :src="require('@/assets/' + methods['intl-cards'].icon)" />
              <div class="method-label">{{ labels['otherMethodsInternationalCardsLabel'] }}</div>
            </div>
            <div class="method-description" v-html="labels['otherMethodsInternationalCardsDescription']"></div>
            <div class="method-footer">
              <a class="button button-outline method-button" target="_blank" :href="methods['intl-cards'].url">{{ labels['otherMethodsInternationalCardsButton'] }}</a>
            </div>
          </div>
          <div class="method-item">
            <div class="method-header">
              <img class="method-icon" :src="require('@/assets/' + methods['btc-eth'].icon)" />
              <div class="method-label">{{ labels['otherMethodsCryptoLabel'] }}</div>
            </div>
            <div class="method-description" v-html="labels['otherMethodsCryptoDescription']"></div>
            <div class="method-footer">
              <a class="button button-outline method-button" target="_blank" :href="methods['btc-eth'].url">{{ labels['otherMethodsCryptoButton'] }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Overlay v-if="showOverlay" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS, VALIDATION_MESSAGES } from '@/settings'

export default {
  computed: mapState({
    email: state => state.donation.email,
    feedback: state => state.unsubscribeReason,
    lang: state => state.language,
    labels: state => LABELS[state.language],
    action: state => LABELS[state.language]['unsubscribe'],
    showConfirmation: state => state.step === 'confirmation',
    showError: state => state.step === 'unsubscribe-error',
    showSuccess: state => state.step === 'success',
    showOverlay: state => (state.step === 'precheckout' || state.step === 'checkout') && state.checkoutType !== 'popup',
    methods: state => state.operators
  }),
  inject: ['$validator'],
  methods: {
    updateEmail (e) {
      const prop = 'email'
      const value = e.target.value
      const change = { prop, value }
      this.$store.commit('updateDonation', change)
    },
    updateFeedback (e) {
      const value = e.target.value
      const change = {
        'unsubscribeReason': value
      }
      this.$store.commit('updateState', change)
    },
    unsubscribe () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('unsubscribe')
        }
      })
    }
  },
  mounted () {
    const lang = this.lang
    this.$validator.localize(lang, VALIDATION_MESSAGES[lang])
  }
}
</script>

<style scoped>
  .oi-donate  .unsubscribe-form {
    font-size: small;
    border-bottom: 1px solid #aaa;
    padding-bottom: 10px;
  }
  .oi-donate  .unsubscribe-form .details {
    margin-bottom: 20px;
  }
  .oi-donate  .unsubscribe-form .message {
    margin: 10px 0;
  }
  .oi-donate  .unsubscribe-form small.help {
    margin: 0 0 5px;
    position: relative;
    top: -5px;
  }
  .oi-donate  .unsubscribe-form .method-header {
    display: flex;
    align-items: center;
    margin: 20px 0 10px;
  }
  .oi-donate  .unsubscribe-form .method-header .method-label {
    font-size: 18px;
    font-weight: 400;
  }
  .oi-donate  .unsubscribe-form .other-methods-title {
    font-size: 20px;
  }

  .oi-donate  .unsubscribe-form .method-header .method-icon {
    width: 40px;
    margin-right: 10px;
  }

  .oi-donate .unsubscribe-form .method-button {
    color: #fff!important;
    background-color: #ef4e23!important;
    border: 1px solid #ef4e23!important;
    margin: 10px 0;
  }
</style>
